import { ChatPanel } from '../ui/ChatPanel.tsx';

export function ChatScreen() {
  return (
    <div className="screen chat-screen">
      <h1 className="visually-hidden">Разговор</h1>
      <ChatPanel />
    </div>
  );
}
